import * as React from 'react';

export type ModalMobileLayoutProps = {
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  /** title node to be displayed in the header strip */
  title?: React.ReactNode;
  /** If true, the title will be sticky to the top of the modal */
  stickyTitle?: boolean;
  /** content node to be displayed */
  content?: React.ReactNode;
  /** footer node to be displayed */
  footer?: React.ReactNode;
  /** If true, the footer will be sticky to the bottom of the modal */
  stickyFooter?: boolean;
  /** callback for when there's a click on the overlay (in case the modal in not fullscreen) */
  onOverlayClick?: () => void;
  /** callback for when the the close button is clicked.  **Note**: if this prop is not provided, then the close button will not be shown. */
  onCloseButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
  /** If true, the modal will take all of the screen */
  fullscreen?: boolean;
};
